import {ReducedInfrastructureConstructionTimesAffectedBuildings, TravianLegendsFeatureSet, TravianVersionWithFeatures} from "../../Version";
import TravianVersion from "../../enum/version";
import {BuildingLevelData} from "../../index";
import BuildingDataT4Base from "../raw/building/base";

export default class BuildingDataHandler {
    constructor(private travianFeatures: TravianVersionWithFeatures) {
        if (this.travianFeatures.version !== TravianVersion.Legends) {
            throw 'Not implemented'
        }
    }

    getGidLevel(gid: number, level: number): null|BuildingLevelData {
        const data = BuildingDataT4Base.find(data => data.gid === gid);
        if (!data) {
            return null;
        }
        const levelData: BuildingLevelData = JSON.parse(JSON.stringify(data.levelData[level]));
        if (!levelData) {
            return null;
        }

        // No support for Kingdoms for now.
        const features: TravianLegendsFeatureSet = this.travianFeatures.features as TravianLegendsFeatureSet;

        // Apply speed-specific patches
        const serverSpeed = features.speed;

        // Building time decreases with speed
        levelData.buildingTime /= serverSpeed;

        // If 40% bonus production from T4.4 is not active, remove it from the data.
        for (let i = 1; i <= 4; i++) {
            if (levelData.effects['production' + i] && !features.increasedResourceProduction) {
                levelData.effects['production' + i] = Math.round(levelData.effects['production' + i] / 1.4);
            }
        }

        // Production of resource fields increases with speed
        for (let i = 1; i <= 4; i++) {
            if (levelData.effects['production' + i]) {
                levelData.effects['production' + i] *= serverSpeed;
            }
        }

        // Party duration decreases with speed
        if (levelData.effects.smallPartyTime) {
            levelData.effects.smallPartyTime /= Math.floor(serverSpeed / 3 + 1);
        }
        if (levelData.effects.largePartyTime) {
            levelData.effects.largePartyTime /= Math.floor(serverSpeed / 3 + 1);
        }
        if (levelData.effects.partyTime) {
            levelData.effects.partyTime /= (serverSpeed > 2 ? (serverSpeed / 2) : 1);
        }

        if (features.reducedInfrastructureConstructionTimes && ReducedInfrastructureConstructionTimesAffectedBuildings.includes(data.gid)) {
            levelData.buildingTime *= 0.75;
        }

        // Round building time ... to 10s-steps for all buildings except WW, there it's 20s-steps.
        levelData.buildingTime = Math.round(levelData.buildingTime / (data.gid === 40 ? 20 : 10)) * 10;

        return levelData;
    }
}
